module.exports = __webpack_public_path__ + "static/media/undraw_blank_canvas.a0e43619.svg";